import React, { Fragment } from 'react'
import { uuid } from 'uuidv4';
import { i18nText } from '../../../Services';

export const InvalidFeedback = props => {
    const { element, errors } = props;

    if (!errors)
        return null;

    const getText = error => {
        let text = null;

        switch (error.name)
        {
            case "valueMissing":
                text = {
                    "fr": "Veuillez renseigner ce champ.",
                    "en": "Please fill out this field."
                }
                break;

            case "typeMismatch":
                if (error.type === "url")
                    text = {
                        "fr": "Veuillez saisir une URL complète.  La valeur du champ doit débuter par http:// ou https://.",
                        "en": "Please enter a URL. The valeur of the field must start with http:// ou https://."
                    }
                else if (error.type === "email")
                {
                    text = {
                        "fr": "Veuillez saisir un courriel valide.",
                        "en": "Please enter a valid e-mail."
                    }
                }
                else
                {
                    text = {
                        "fr": "Veuillez saisir une valeur valide.",
                        "en": "Please enter a valid value."
                    }
                }
                break;

            case "patternMismatch":
                text = {
                    "fr": "Veuillez respecter le format requis.",
                    "en": "Please match the requested format."
                }
                break;

            case "tooLong":
                text = {
                    "fr": "Veuillez modifier ce texte pour qu'il comporte au plus {{maxLength}} caractère(s). Il en compte actuellement {{length}}.",
                    "en": "Please edit this text to {{maxLength}} caracter(s) or less.  You currently using {{length}} caracter(s)."
                }
                break;

            case "tooShort":
                text = {
                    "fr": "Veuillez modifier ce texte pour qu'il comporte au moins {{minLength}} caractère(s). Il en compte actuellement {{length}}.",
                    "en": "Please edit this text to {{minLength}} caracter(s) or more.  You currently using {{length}} caracter(s)."
                }
                break;

            case "rangeUnderflow":
                text = {
                    "fr": "Cette valeur doit être supérieure ou égale à {{min}}.",
                    "en": "Value must be greater than or equal to {{min}}."
                }
                break;

            case "rangeOverflow":
                text = {
                    "fr": "Cette valeur doit être inférieure ou égale à {{max}}.",
                    "en": "Value must be less than or equal to {{max}}."
                }
                break;

            case "stepMismatch":
                const floor = Math.floor(error.value);
                text = {
                    "fr": `Veuillez saisir une valeur valide. Les deux valeurs valides les plus proches sont "${floor}" et "${floor + error.step}".`,
                    "en": `Please enter a valid value.  The two nearest valid values are "${floor}" et "${floor + error.step}".`
                }
                break;

            case "badInput":
                text = {
                    "fr": "Veuillez saisir une valeur valide. Le champ n'est pas complet ou contient une valeur invalide.",
                    "en": "Please enter a valid value.  The field is incomplete or has an invalid value."
                }
                break;

            case "invalidEmailorPhone":
                text = {
                    "fr": "Veuillez saisir un courriel ou un numéro de téléphone valide.",
                    "en": "Please enter a valid e-mail or phone number."
                }
                break;

            case "invalidEmail":
                text = {
                    "fr": "Veuillez saisir un courriel valide.",
                    "en": "Please enter a valid e-mail."
                }
                break;

            case "invalidPhone":
                text = {
                    "fr": "Veuillez saisir un numéro de téléphone valide.",
                    "en": "Please enter a valid phone number."
                }
                break;

            case "repeaterMin":
                text = {
                    "fr": `Veuillez modifier cette liste pour qu'elle contienne au moins {{min}} item(s). Elle en compte actuellement {{length}}.`,
                    "en": `Please edit this list so that it contains at least {{min}} item(s) or more.  You currently using {{length}}.`
                }
                break;

            case "repeaterMax":
                text = {
                    "fr": `Veuillez modifier cette liste pour qu'elle contienne au plus {{max}} item(s). Elle en compte actuellement {{length}}.`,
                    "en": `Please edit this list so that it contains at most {{max}} item(s) or less.  You currently using {{length}}.`
                }
                break;

            default:
                const validation = element.validations.filter(v => v.name === error.name);
                text = validation.length > 0 ?  validation[0].text : { "fr": "Une règle n'est pas respectée.", "en": "A rule is not respected." };
                break;
        }

        return i18nText.getText(text, error);
    }

    return (<div className="invalid-feedback d-block">{errors.map(error => <Fragment key={uuid()}>{getText(error)}<br/></Fragment>) }</div>)
}

export default InvalidFeedback;